(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('pdp-product')) return;

    var MONEY_RE = /\{\{\s*(\w+)\s*\}\}/;

    function fmtNumber(cents, decimals, thousands, decimal) {
      var fixed = (Number(cents || 0) / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    }

    function formatMoney(cents, format) {
      format = format || '';
      var match = format.match(MONEY_RE);
      if (!match) return fmtNumber(cents, 2, ' ', ',');
      var v;
      switch (match[1]) {
        case 'amount_no_decimals': v = fmtNumber(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': v = fmtNumber(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': v = fmtNumber(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': v = fmtNumber(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': v = fmtNumber(cents, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': v = fmtNumber(cents, 2, "'", '.'); break;
        default: v = fmtNumber(cents, 2, ',', '.');
      }
      return format.replace(MONEY_RE, v);
    }

    class PdpProduct extends HTMLElement {
      connectedCallback() {
        var json = this.querySelector('[data-pdp-variants]');
        try { this.variants = json ? JSON.parse(json.textContent) : []; } catch (e) { this.variants = []; }
        this.moneyFormat = this.dataset.moneyFormat;
        this.threshold = parseInt(this.dataset.lowStock || '0', 10);
        var root = this.dataset.root || '/';
        this.root = root.charAt(root.length - 1) === '/' ? root : root + '/';
        this.form = this.querySelector('form.pdp-form');
        this.variantInput = this.querySelector('[data-variant-id]');
        var initialId = Number(this.dataset.currentVariant);
        this.currentVariant = this.variants.find(function (v) { return v.id === initialId; }) || this.variants[0];
        this.observers = [];

        this.initGallery();
        this.initOptions();
        this.initAddons();
        this.initPacks();
        this.initQuantity();
        this.initForm();
        this.initSticky();
        this.initLightbox();
        this.updateTotals();
      }

      disconnectedCallback() {
        (this.observers || []).forEach(function (o) { o.disconnect(); });
      }

      money(cents) { return formatMoney(cents, this.moneyFormat); }

      /* ---------- Galerie ---------- */
      initGallery() {
        var self = this;
        this.track = this.querySelector('[data-gallery-track]');
        if (!this.track) return;
        this.allSlides = Array.from(this.track.children);
        this.allThumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
        this.allDots = Array.from(this.querySelectorAll('[data-dot-index]'));
        this.groupMedia = this.dataset.groupMedia === 'true';
        this.counter = this.querySelector('[data-gallery-counter]');
        this.activeIndex = -1;
        this.lockUntil = 0;
        this.refreshVisible();

        this.allThumbs.forEach(function (t) { t.addEventListener('click', function () { self.goTo(self.thumbs.indexOf(t)); }); });
        this.allDots.forEach(function (d) { d.addEventListener('click', function () { self.goTo(self.dots.indexOf(d)); }); });
        var prev = this.querySelector('[data-gallery-prev]');
        var next = this.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', function () { self.goTo(self.activeIndex - 1); });
        if (next) next.addEventListener('click', function () { self.goTo(self.activeIndex + 1); });

        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking || Date.now() < self.lockUntil) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var w = self.track.clientWidth || 1;
            self.setActive(Math.round(self.track.scrollLeft / w));
          });
        }, { passive: true });

        var featuredId = this.dataset.featuredMedia;
        var start = Math.max(0, this.slides.findIndex(function (s) { return s.dataset.mediaId === featuredId; }));
        this.setActive(start);
        if (start > 0) requestAnimationFrame(function () { self.goTo(start, 'auto'); });
      }

      refreshVisible() {
        var visible = function (el) { return !el.hidden; };
        this.slides = this.allSlides.filter(visible);
        this.thumbs = this.allThumbs.filter(visible);
        this.dots = this.allDots.filter(visible);
        this.activeIndex = -1;
      }

      /* Affiche les photos communes + celles de la couleur choisie. */
      applyMediaGroup(mediaId) {
        if (!this.groupMedia || !this.allSlides) return false;
        var key = mediaId == null ? '' : String(mediaId);
        var isGroup = key !== '' && this.allSlides.some(function (s) { return s.dataset.group === key; });
        var current = this.slides.map(function (s) { return s.dataset.mediaId; }).join(',');
        [this.allSlides, this.allThumbs, this.allDots].forEach(function (list) {
          list.forEach(function (el) { el.hidden = isGroup && el.dataset.group !== '' && el.dataset.group !== key; });
        });
        this.allSlides.forEach(function (sl) { if (sl.hidden) sl.querySelectorAll('video').forEach(function (vid) { vid.pause(); }); });
        this.refreshVisible();
        return this.slides.map(function (s) { return s.dataset.mediaId; }).join(',') !== current;
      }

      goTo(i, behavior) {
        if (!this.slides || !this.slides.length) return;
        var n = this.slides.length;
        var idx = ((i % n) + n) % n;
        this.lockUntil = Date.now() + 450;
        this.track.scrollTo({ left: idx * this.track.clientWidth, behavior: behavior || 'smooth' });
        this.setActive(idx);
      }

      goToMedia(mediaId) {
        if (!this.slides) return;
        var idx = this.slides.findIndex(function (s) { return Number(s.dataset.mediaId) === Number(mediaId); });
        if (idx > -1) this.goTo(idx);
      }

      setActive(i) {
        if (!this.slides || i === this.activeIndex || i < 0 || i >= this.slides.length) return;
        this.activeIndex = i;
        this.thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
        this.slides.forEach(function (s, k) {
          s.querySelectorAll('video').forEach(function (v) {
            if (k === i) { if (v.autoplay) v.play().catch(function () {}); } else { v.pause(); }
          });
        });
        var thumb = this.thumbs[i];
        var wrap = thumb && thumb.parentElement;
        if (thumb && wrap) {
          if (wrap.scrollHeight > wrap.clientHeight + 1) {
            wrap.scrollTo({ top: thumb.offsetTop - wrap.clientHeight / 2 + thumb.clientHeight / 2, behavior: 'smooth' });
          } else if (wrap.scrollWidth > wrap.clientWidth + 1) {
            wrap.scrollTo({ left: thumb.offsetLeft - wrap.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
          }
        }
      }

      /* ---------- Variantes ---------- */
      initOptions() {
        var self = this;
        this.fieldsets = Array.from(this.querySelectorAll('[data-option-index]'));
        if (!this.fieldsets.length) return;
        this.fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { self.onOptionChange(); }); });
        this.updateAvailability();
      }

      selectedOptions() {
        return this.fieldsets.map(function (fs) {
          var input = fs.querySelector('input:checked');
          return input ? input.value : null;
        });
      }

      onOptionChange() {
        var sel = this.selectedOptions();
        var v = this.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) {
          for (var depth = sel.length - 1; depth >= 1 && !v; depth--) {
            var candidates = this.variants.filter(function (x) { return x.options.slice(0, depth).every(function (o, i) { return o === sel[i]; }); });
            v = candidates.find(function (x) { return x.available; }) || candidates[0];
          }
          if (!v) v = this.variants[0];
          this.checkOptions(v.options);
        }
        this.setVariant(v);
      }

      checkOptions(options) {
        this.fieldsets.forEach(function (fs, i) {
          var input = Array.from(fs.querySelectorAll('input')).find(function (x) { return x.value === options[i]; });
          if (input) input.checked = true;
        });
      }

      updateAvailability() {
        var self = this;
        var sel = this.selectedOptions();
        this.fieldsets.forEach(function (fs, i) {
          fs.querySelectorAll('input').forEach(function (input) {
            var ok = self.variants.some(function (v) {
              return v.available && v.options[i] === input.value && v.options.slice(0, i).every(function (o, k) { return o === sel[k]; });
            });
            if (input.nextElementSibling) input.nextElementSibling.classList.toggle('is-unavailable', !ok);
          });
          var label = fs.querySelector('[data-selected-value]');
          if (label) label.textContent = sel[i] || '';
        });
      }

      setVariant(v) {
        if (!v) return;
        this.currentVariant = v;
        if (this.variantInput) this.variantInput.value = v.id;
        this.updatePrice(v);
        this.updateStock(v);
        this.updateButtons(v);
        if (this.fieldsets && this.fieldsets.length) this.updateAvailability();
        this.updateTotals();
        var stickyVariant = this.querySelector('[data-sticky-variant]');
        if (stickyVariant) stickyVariant.textContent = v.title;
        var groupChanged = this.applyMediaGroup(v.featured_media_id);
        if (v.featured_media_id) {
          if (groupChanged) {
            var gi = this.slides.findIndex(function (s) { return Number(s.dataset.mediaId) === Number(v.featured_media_id); });
            this.goTo(Math.max(0, gi), 'auto');
          } else {
            this.goToMedia(v.featured_media_id);
          }
        } else if (groupChanged) {
          this.goTo(0, 'auto');
        }
        if (!(window.Shopify && window.Shopify.designMode)) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        this.dispatchEvent(new CustomEvent('pdp:variant-change', { bubbles: true, detail: { variant: v } }));
      }

      updatePrice(v) {
        var self = this;
        var onSale = v.compare_at_price > v.price;
        this.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = self.money(v.price); });
        this.querySelectorAll('[data-compare-price]').forEach(function (el) {
          el.textContent = onSale ? self.money(v.compare_at_price) : '';
          el.hidden = !onSale;
        });
        this.querySelectorAll('[data-sale-badge]').forEach(function (el) {
          el.hidden = !onSale;
          if (!onSale) return;
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          el.textContent = (el.dataset.format || '-[percent]%')
            .replace('[percent]', pct)
            .replace('[amount]', self.money(v.compare_at_price - v.price));
        });
      }

      updateStock(v) {
        var el = this.querySelector('[data-stock]');
        if (!el) return;
        var state = 'in';
        if (!v.available) state = 'out';
        else if (v.inventory_quantity !== null && v.inventory_quantity > 0 && v.inventory_quantity <= this.threshold) state = 'low';
        el.dataset.state = state;
        var txt = el.querySelector('[data-stock-text]');
        if (txt) txt.textContent = (el.dataset[state] || '').replace('[count]', v.inventory_quantity == null ? '' : v.inventory_quantity);
      }

      updateButtons(v) {
        this.querySelectorAll('[data-atc], [data-sticky-atc]').forEach(function (btn) {
          btn.disabled = !v.available;
          var label = btn.querySelector('[data-atc-label]');
          if (label) label.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        });
      }

      /* ---------- Accessoires ---------- */
      initAddons() {
        var self = this;
        this.addonInputs = Array.from(this.querySelectorAll('[data-addon-input]'));
        this.addonInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            var item = input.closest('[data-addon]');
            if (item) item.classList.toggle('is-selected', input.checked);
            self.updateTotals();
          });
        });
        this.querySelectorAll('[data-addon-select]').forEach(function (sel) {
          sel.addEventListener('change', function () {
            var item = sel.closest('[data-addon]');
            var input = item.querySelector('[data-addon-input]');
            var opt = sel.selectedOptions[0];
            var list = sel.closest('[data-addon-off]');
            var off = list ? Number(list.dataset.addonOff || 0) : 0;
            var base = Number(opt.dataset.price);
            var price = Math.max(base - off, 0);
            var compare = Number(opt.dataset.compare || 0);
            if (off > 0 && base > compare) compare = base;
            input.value = opt.value;
            input.dataset.price = price;
            var priceEl = item.querySelector('[data-addon-price]');
            if (priceEl) priceEl.textContent = self.money(price);
            var compareEl = item.querySelector('[data-addon-compare]');
            if (compareEl) { compareEl.hidden = !(compare > price); compareEl.textContent = compare > price ? self.money(compare) : ''; }
            self.updateTotals();
          });
        });
        var toggle = this.querySelector('[data-addons-toggle]');
        if (toggle) {
          toggle.addEventListener('click', function () {
            var open = toggle.getAttribute('aria-expanded') === 'true';
            self.querySelectorAll('[data-addon-extra]').forEach(function (el) { el.hidden = open; });
            toggle.setAttribute('aria-expanded', String(!open));
            toggle.textContent = open ? toggle.dataset.more : toggle.dataset.less;
          });
        }
      }

      /* ---------- Quantité & total ---------- */
      initQuantity() {
        var self = this;
        this.qtyInput = this.querySelector('[data-qty]');
        var minus = this.querySelector('[data-qty-minus]');
        var plus = this.querySelector('[data-qty-plus]');
        if (minus) minus.addEventListener('click', function () { self.setQty(self.qty() - 1); });
        if (plus) plus.addEventListener('click', function () { self.setQty(self.qty() + 1); });
        if (this.qtyInput) this.qtyInput.addEventListener('change', function () { self.setQty(self.qty()); });
      }

      qty() {
        var pack = this.selectedPack();
        if (pack) return Math.max(1, Number(pack.dataset.qty || 1));
        return Math.max(1, parseInt((this.qtyInput && this.qtyInput.value) || '1', 10) || 1);
      }

      /* ---------- Packs (1 carte, 2 + 1 offerte…) ---------- */
      initPacks() {
        var self = this;
        this.packInputs = Array.from(this.querySelectorAll('[data-pack-input]'));
        if (!this.packInputs.length) return;
        if (!this.selectedPack()) {
          var first = this.packInputs.find(function (i) { return !i.disabled; });
          if (first) first.checked = true;
        }
        this.packInputs.forEach(function (input) {
          input.addEventListener('change', function () { self.updateTotals(); });
        });
      }

      selectedPack() {
        return (this.packInputs || []).find(function (i) { return i.checked && !i.disabled; }) || null;
      }

      renderPacks(v) {
        var self = this;
        (this.packInputs || []).forEach(function (input) {
          var label = input.closest('.pdp-pack');
          var qty = Math.max(1, Number(input.dataset.qty || 1));
          var full = v.price * qty;
          var off = Math.min(Number(input.dataset.off || 0), full);
          var total = full - off;
          var compare = (v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price) * qty;
          var set = function (sel, txt) { var el = label.querySelector(sel); if (el) el.textContent = txt; return el; };
          set('[data-pack-total]', self.money(total));
          var c = set('[data-pack-compare]', self.money(compare)); if (c) c.hidden = !(compare > total);
          set('[data-pack-unit]', self.money(Math.floor(total / qty)));
          set('[data-pack-save]', self.money(compare - total));
          var w = label.querySelector('[data-pack-save-wrap]'); if (w) w.hidden = !(compare > total);
        });
      }

      setQty(n) {
        if (this.qtyInput) this.qtyInput.value = Math.max(1, n);
        this.updateTotals();
      }

      updateTotals() {
        var v = this.currentVariant;
        if (!v) return;
        var self = this;
        if (this.packInputs && this.packInputs.length) this.renderPacks(v);
        var total = v.price * this.qty();
        var pack = this.selectedPack();
        if (pack) total -= Math.min(Number(pack.dataset.off || 0), total);
        var anyAddon = false;
        (this.addonInputs || []).forEach(function (i) { if (i.checked && !i.disabled) { total += Number(i.dataset.price || 0); anyAddon = true; } });
        var list = this.querySelector('[data-main-off]');
        var mainOff = list ? Number(list.dataset.mainOff || 0) : 0;
        if (anyAddon && mainOff > 0) total -= Math.min(mainOff, v.price) * this.qty();
        this.querySelectorAll('[data-atc-price], [data-sticky-price]').forEach(function (el) { el.textContent = self.money(total); });
      }

      /* ---------- Ajout au panier ---------- */
      initForm() {
        var self = this;
        if (!this.form) return;
        this.errorEl = this.form.querySelector('[data-form-error]');
        this.successEl = this.form.querySelector('[data-form-success]');
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = self.currentVariant;
          if (!v || !v.available) return;
          var items = [{ id: v.id, quantity: self.qty() }];
          (self.addonInputs || []).forEach(function (i) {
            if (i.checked && !i.disabled) items.push({ id: Number(i.value), quantity: 1 });
          });
          self.addToCart(items);
        });
      }

      addToCart(items) {
        var self = this;
        var btn = this.form.querySelector('[data-atc]');
        var redirecting = false;
        var mode = this.dataset.afterAdd;
        var themeCart = mode === 'theme' ? (document.querySelector('cart-drawer') || document.querySelector('cart-notification')) : null;
        if (themeCart && typeof themeCart.getSectionsToRender !== 'function') themeCart = null;
        var payload = { items: items };
        if (themeCart) {
          payload.sections = themeCart.getSectionsToRender().map(function (s) { return s.section || s.id; });
          payload.sections_url = window.location.pathname;
          if (typeof themeCart.setActiveElement === 'function') themeCart.setActiveElement(document.activeElement);
        }
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
        if (this.errorEl) this.errorEl.hidden = true;

        return fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok || data.status) throw new Error(data.description || data.message || 'Une erreur est survenue.');
              return data;
            });
          })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('pdp:added-to-cart', { detail: { items: items, response: data } }));
            if (themeCart && data.sections) {
              var first = (data.items && data.items[0]) || {};
              var state = Object.assign({}, first, { sections: data.sections });
              themeCart.classList.remove('is-empty');
              themeCart.renderContents(state);
            } else if (mode === 'checkout') {
              redirecting = true;
              window.location.href = self.root + 'checkout';
            } else if (mode === 'stay') {
              self.showSuccess();
              self.refreshCartCount();
            } else {
              redirecting = true;
              window.location.href = self.dataset.cartUrl || self.root + 'cart';
            }
          })
          .catch(function (err) {
            if (self.errorEl) { self.errorEl.textContent = err.message; self.errorEl.hidden = false; }
          })
          .finally(function () {
            if (!redirecting && btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
          });
      }

      showSuccess() {
        var el = this.successEl;
        if (!el) return;
        el.hidden = false;
        clearTimeout(this.successTimer);
        this.successTimer = setTimeout(function () { el.hidden = true; }, 4000);
      }

      refreshCartCount() {
        fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function () {});
      }

      /* ---------- Barre fixe ---------- */
      initSticky() {
        var self = this;
        this.sticky = this.querySelector('[data-sticky]');
        var anchor = this.querySelector('[data-atc]') || this.querySelector('.pdp__info');
        if (!this.sticky || !anchor || !('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          self.sticky.classList.toggle('is-visible', show);
          self.sticky.inert = !show;
        });
        io.observe(anchor);
        this.observers.push(io);
        var btn = this.sticky.querySelector('[data-sticky-atc]');
        if (btn) {
          btn.addEventListener('click', function () {
            if (self.form && self.currentVariant && self.currentVariant.available) {
              if (self.form.requestSubmit) self.form.requestSubmit(); else self.form.dispatchEvent(new Event('submit', { cancelable: true }));
            } else {
              var info = self.querySelector('.pdp__info');
              if (info) info.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        }
      }

      /* ---------- Zoom ---------- */
      initLightbox() {
        var dlg = this.querySelector('[data-lightbox]');
        if (!dlg || typeof dlg.showModal !== 'function') return;
        var img = dlg.querySelector('[data-lightbox-img]');
        this.querySelectorAll('[data-zoom]').forEach(function (b) {
          b.addEventListener('click', function () {
            var inner = b.querySelector('img');
            img.src = b.dataset.zoom;
            img.alt = inner ? inner.alt : '';
            dlg.showModal();
          });
        });
        var close = dlg.querySelector('[data-lightbox-close]');
        if (close) close.addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }
    }

    customElements.define('pdp-product', PdpProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('pdp-countup')) return;
    class PdpCountup extends HTMLElement {
      connectedCallback() {
        var self = this;
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          self.io.disconnect();
          self.querySelectorAll('[data-count-to]').forEach(function (el) { self.animate(el); });
        }, { threshold: 0.4 });
        this.io.observe(this);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      animate(el) {
        var raw = (el.dataset.countTo || '').replace(/\s/g, '');
        if (!/^\d+$/.test(raw)) return;
        var target = parseInt(raw, 10);
        var lang = document.documentElement.lang || 'fr';
        var start = performance.now();
        var duration = 1400;
        function frame(now) {
          var p = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString(lang);
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      }
    }
    customElements.define('pdp-countup', PdpCountup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-tabs')) {
    customElements.define('pdp-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            let n = null;
            if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') n = 0;
            if (e.key === 'End') n = this.tabs.length - 1;
            if (n !== null) { e.preventDefault(); this.select(n); this.tabs[n].focus(); }
          });
        });
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.findIndex((t) => t.id === 'pt-tab-' + e.detail.blockId);
          if (i > -1) this.select(i);
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('zp-announcement')) return;
    class ZpAnnouncement extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.msgs = Array.from(this.querySelectorAll('[data-ann-msg]'));
        this.index = 0;
        if (this.msgs.length < 2) return;
        var prev = this.querySelector('[data-ann-prev]');
        var next = this.querySelector('[data-ann-next]');
        if (prev) prev.addEventListener('click', function () { self.show(self.index - 1); self.restart(); });
        if (next) next.addEventListener('click', function () { self.show(self.index + 1); self.restart(); });
        this.addEventListener('mouseenter', function () { self.stop(); });
        this.addEventListener('mouseleave', function () { self.restart(); });
        this.addEventListener('focusin', function () { self.stop(); });
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      show(i) {
        var n = this.msgs.length;
        this.index = ((i % n) + n) % n;
        var idx = this.index;
        this.msgs.forEach(function (m, k) {
          m.classList.toggle('is-active', k === idx);
          if (k === idx) m.removeAttribute('aria-hidden'); else m.setAttribute('aria-hidden', 'true');
        });
      }
      stop() { clearInterval(this.timer); }
      restart() {
        var self = this;
        this.stop();
        var s = parseInt(this.dataset.interval || '5', 10);
        if (s > 0) this.timer = setInterval(function () { self.show(self.index + 1); }, s * 1000);
      }
    }
    customElements.define('zp-announcement', ZpAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-header"] && !Shopify.designMode) return;
  try {
    
  /* Ferme le sélecteur de pays quand on clique ailleurs ou sur Échap */
  (function () {
    if (window.zhCountryBound) return;
    window.zhCountryBound = true;
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-country-picker][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-country-picker][open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary'); if (s) s.focus();
      });
    });
  })();
  (function () {
    if (customElements.get('zp-header')) return;

    class ZpHeader extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.zh__bar');
        this.wrapper = this.closest('.shopify-section') || this.parentElement;
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.current = null;
        this.lastY = window.scrollY;
        this.onScroll = this.onScroll.bind(this);
        this.onKey = this.onKey.bind(this);

        if (this.dataset.sticky === 'none' && this.wrapper) this.wrapper.classList.add('zh-static');
        this.measure();
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.measure.bind(this));
          this.ro.observe(this.bar);
        }
        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('keydown', this.onKey);
        this.onScroll();

        this.initPanels();
        this.initSearch();
        this.initDrawer();
        this.initCartIcon();
        var overlay = this.querySelector('[data-overlay]');
        var self = this;
        if (overlay) overlay.addEventListener('click', function () { self.closePanel(); self.closeSearch(); });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('keydown', this.onKey);
        if (this.ro) this.ro.disconnect();
        if (this.cartMo) this.cartMo.disconnect();
        document.documentElement.classList.remove('zh-lock');
        document.body.style.overflow = '';
      }

      initCartIcon() {
        var link = this.querySelector('#cart-icon-bubble');
        var tpl = this.querySelector('template[data-cart-icon-tpl]');
        if (!link || !tpl || !('MutationObserver' in window)) return;
        var fix = function () {
          var dawn = link.querySelector('.icon-cart, .icon-cart-empty');
          if (!dawn) return;
          var target = dawn.closest('.svg-wrapper') || dawn;
          target.replaceWith(tpl.content.cloneNode(true));
        };
        fix();
        this.cartMo = new MutationObserver(fix);
        this.cartMo.observe(link, { childList: true, subtree: true });
      }

      measure() {
        var h = this.offsetHeight || this.bar.offsetHeight;
        document.documentElement.style.setProperty('--zh-h', h + 'px');
      }

      onScroll() {
        var y = window.scrollY;
        this.classList.toggle('is-scrolled', y > 4);
        this.updateSolid();
        if (this.dataset.sticky === 'on-scroll-up' && this.wrapper) {
          var hide = y > this.lastY && y > this.bar.offsetHeight * 2 && !this.current && !this.searchOpen;
          this.wrapper.classList.toggle('zh-hidden', hide);
        }
        this.lastY = y;
      }

      updateSolid() {
        var solid = window.scrollY > 10 || !!this.current || !!this.searchOpen || this.matches(':hover');
        this.classList.toggle('is-solid', solid);
      }

      onKey(e) {
        if (e.key !== 'Escape') return;
        if (this.current) {
          var trigger = this.current.querySelector('[data-panel-trigger]');
          this.closePanel();
          if (trigger) trigger.focus();
        }
        if (this.searchOpen) this.closeSearch(true);
        if (this.drawerOpen) this.closeDrawer();
      }

      /* ---------- Méga-menu ---------- */
      initPanels() {
        var self = this;
        this.addEventListener('mouseenter', function () { self.updateSolid(); });
        this.addEventListener('mouseleave', function () { self.updateSolid(); });
        this.querySelectorAll('[data-panel-item]').forEach(function (item) {
          var trigger = item.querySelector('[data-panel-trigger]');
          item.addEventListener('mouseenter', function () {
            if (!self.desktop.matches) return;
            clearTimeout(self.closeTimer);
            clearTimeout(self.openTimer);
            self.openTimer = setTimeout(function () { self.openPanel(item); }, self.current ? 0 : 90);
          });
          item.addEventListener('mouseleave', function () {
            clearTimeout(self.openTimer);
            self.closeTimer = setTimeout(function () { self.closePanel(item); }, 180);
          });
          trigger.addEventListener('pointerdown', function (e) { self.lastPointer = e.pointerType; });
          trigger.addEventListener('click', function (e) {
            if (self.lastPointer && self.lastPointer !== 'mouse' && self.current !== item) {
              e.preventDefault();
              self.openPanel(item);
            }
            self.lastPointer = null;
          });
          trigger.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown' || e.key === ' ') {
              e.preventDefault();
              self.openPanel(item);
              var first = item.querySelector('[data-panel] a');
              if (first) setTimeout(function () { first.focus(); }, 50);
            }
          });
          item.addEventListener('focusout', function (e) {
            if (!item.contains(e.relatedTarget)) self.closePanel(item);
          });
        });
      }

      openPanel(item) {
        if (this.current && this.current !== item) this.closePanel(this.current);
        if (this.searchOpen) this.closeSearch();
        this.current = item;
        item.classList.add('is-open');
        var trigger = item.querySelector('[data-panel-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        this.classList.toggle('is-panel-open', item.classList.contains('zh__item--mega'));
        this.updateSolid();
      }

      closePanel(item) {
        var target = item || this.current;
        if (!target) return;
        target.classList.remove('is-open');
        var trigger = target.querySelector('[data-panel-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (this.current === target) this.current = null;
        if (!this.current) this.classList.remove('is-panel-open');
        this.updateSolid();
      }

      /* ---------- Recherche ---------- */
      initSearch() {
        var self = this;
        this.searchPanel = this.querySelector('[data-search-panel]');
        if (!this.searchPanel) return;
        this.searchBtn = this.querySelector('[data-search-open]');
        this.searchInput = this.querySelector('[data-search-input]');
        this.results = this.querySelector('[data-search-results]');
        this.popular = this.querySelector('[data-search-popular]');
        this.searchBtn.addEventListener('click', function () { self.searchOpen ? self.closeSearch() : self.openSearch(); });
        this.querySelector('[data-search-close]').addEventListener('click', function () { self.closeSearch(true); });
        this.searchInput.addEventListener('input', function () {
          clearTimeout(self.searchTimer);
          self.searchTimer = setTimeout(function () { self.runSearch(self.searchInput.value.trim()); }, 220);
        });
      }

      openSearch() {
        this.closePanel();
        this.searchOpen = true;
        this.searchPanel.hidden = false;
        this.classList.add('is-search-open');
        this.searchBtn.setAttribute('aria-expanded', 'true');
        this.updateSolid();
        var input = this.searchInput;
        setTimeout(function () { input.focus(); }, 30);
      }

      closeSearch(returnFocus) {
        if (!this.searchOpen) return;
        this.searchOpen = false;
        this.searchPanel.hidden = true;
        this.classList.remove('is-search-open');
        this.searchBtn.setAttribute('aria-expanded', 'false');
        this.updateSolid();
        if (returnFocus) this.searchBtn.focus();
      }

      runSearch(q) {
        var self = this;
        if (this.popular) this.popular.hidden = q.length > 0;
        if (q.length < 2) { this.results.innerHTML = ''; return; }
        var url = this.dataset.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        var token = (this.searchToken = (this.searchToken || 0) + 1);
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (token !== self.searchToken) return;
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            self.renderResults(products, q);
          })
          .catch(function () { self.results.innerHTML = ''; });
      }

      renderResults(products, q) {
        var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
        var currency = this.dataset.currency || 'EUR';
        var locale = this.dataset.locale || 'fr';
        var fmt = function (v) {
          var n = parseFloat(v);
          if (isNaN(n)) return '';
          try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(n); } catch (e) { return n.toFixed(2); }
        };
        var allUrl = this.dataset.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        if (!products.length) {
          this.results.innerHTML = '<p class="zh__results-empty">Aucun produit trouvé pour « ' + esc(q) + ' ».</p>';
          return;
        }
        var html = '<div class="zh__results">' + products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image;
          var media = img ? '<img src="' + esc(img) + (String(img).indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="56" height="56">' : '<span class="zh__result-ph"></span>';
          return '<a class="zh__result" href="' + esc(p.url) + '">' + media + '<span><span class="zh__result-title">' + esc(p.title) + '</span><span class="zh__result-price">' + esc(fmt(p.price)) + '</span></span></a>';
        }).join('') + '</div><a class="zh__results-all" href="' + esc(allUrl) + '">Voir tous les résultats</a>';
        this.results.innerHTML = html;
      }

      /* ---------- Menu mobile ---------- */
      initDrawer() {
        var self = this;
        this.drawer = this.querySelector('[data-drawer]');
        this.burger = this.querySelector('[data-drawer-open]');
        if (!this.drawer || !this.burger) return;
        this.burger.addEventListener('click', function () { self.openDrawer(); });
        this.drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeDrawer(); }); });
        this.desktop.addEventListener('change', function (e) { if (e.matches) self.closeDrawer(); });
      }

      openDrawer() {
        this.drawerOpen = true;
        this.drawer.classList.add('is-open');
        this.drawer.removeAttribute('inert');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        var close = this.drawer.querySelector('.zh__drawer-head [data-drawer-close]');
        if (close) setTimeout(function () { close.focus(); }, 50);
      }

      closeDrawer() {
        if (!this.drawerOpen) return;
        this.drawerOpen = false;
        this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('inert', '');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        this.burger.focus();
      }
    }

    customElements.define('zp-header', ZpHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('zp-slider')) return;
    class ZpSlider extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.interval = parseInt(this.dataset.autoplay || '0', 10);
        this.style.setProperty('--zp-hero-interval', this.interval + 's');
        if (this.slides.length < 2) return;
        this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(Number(d.dataset.dot)); self.restart(); }); });
        var prev = this.querySelector('[data-prev]');
        var next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var i = Math.round(self.track.scrollLeft / (self.track.clientWidth || 1));
            if (i !== self.index) { self.setActive(i); self.restart(); }
          });
        }, { passive: true });
        this.addEventListener('mouseenter', function () { self.pause(true); });
        this.addEventListener('mouseleave', function () { self.pause(false); });
        this.addEventListener('focusin', function () { self.pause(true); });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.pause(false); });
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.restart();
      }
      disconnectedCallback() { clearInterval(this.timer); }
      go(i) {
        var n = this.slides.length;
        var idx = ((i % n) + n) % n;
        this.track.scrollTo({ left: idx * this.track.clientWidth, behavior: this.reduced ? 'auto' : 'smooth' });
        this.setActive(idx);
      }
      setActive(i) {
        this.index = i;
        this.dots.forEach(function (d, k) {
          d.classList.remove('is-active');
          if (k === i) { void d.offsetWidth; d.classList.add('is-active'); }
        });
      }
      pause(on) {
        this.paused = on;
        this.classList.toggle('is-paused', on);
        if (on) clearInterval(this.timer); else this.restart();
      }
      restart() {
        var self = this;
        clearInterval(this.timer);
        if (!this.interval || this.paused || this.reduced) return;
        this.setActive(this.index);
        this.timer = setInterval(function () { self.go(self.index + 1); }, this.interval * 1000);
      }
    }
    customElements.define('zp-slider', ZpSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-offers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('zp-offers')) return;
    var RE = /\{\{\s*(\w+)\s*\}\}/;
    function num(c, d, t, s) { var p = (Number(c || 0) / 100).toFixed(d).split('.'); var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p[1] ? i + s + p[1] : i; }
    function money(c, f) {
      var m = (f || '').match(RE); if (!m) return num(c, 2, ' ', ',');
      var v;
      switch (m[1]) {
        case 'amount_no_decimals': v = num(c, 0, ',', '.'); break;
        case 'amount_with_comma_separator': v = num(c, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': v = num(c, 0, '.', ','); break;
        case 'amount_with_space_separator': v = num(c, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': v = num(c, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': v = num(c, 2, "'", '.'); break;
        default: v = num(c, 2, ',', '.');
      }
      return f.replace(RE, v);
    }

    class ZpOffers extends HTMLElement {
      connectedCallback() {
        var self = this;
        var root = this.dataset.root || '/';
        this.root = root.charAt(root.length - 1) === '/' ? root : root + '/';
        this.querySelectorAll('[data-offer]').forEach(function (card) {
          card.addEventListener('change', function (e) {
            var input = e.target;
            if (!input.matches('input[type="radio"]')) return;
            var line = input.closest('[data-line]');
            line.dataset.variant = input.value;
            line.dataset.price = input.dataset.price;
            line.dataset.compare = input.dataset.compare;
            line.dataset.available = input.dataset.available;
            var lbl = line.querySelector('[data-opt-value]');
            if (lbl) lbl.textContent = input.dataset.name;
            self.swapImage(card, input);
            self.update(card);
          });
          var btn = card.querySelector('[data-add]');
          if (btn) btn.addEventListener('click', function () { self.add(card, btn); });
        });
      }

      swapImage(card, input) {
        var src = input.dataset.img;
        var img = card.querySelector('img.zp-off__img');
        if (!src || !img || img.getAttribute('src') === src) return;
        img.style.opacity = '0';
        var next = new Image();
        next.onload = next.onerror = function () {
          if (input.dataset.srcset) img.srcset = input.dataset.srcset;
          img.src = src;
          img.style.opacity = '1';
        };
        next.src = src;
      }

      update(card) {
        var f = this.dataset.moneyFormat;
        var lines = Array.from(card.querySelectorAll('[data-line]'));
        var total = 0, compare = 0, ok = lines.length > 0;
        var off = Number(card.dataset.packOff || 0);
        var qty = Math.max(1, Number(card.dataset.qty || 1));
        lines.forEach(function (l, i) {
          var price = Number(l.dataset.price || 0);
          total += price * qty;
          compare += Number(l.dataset.compare || 0) * qty;
          if (l.dataset.available !== 'true') ok = false;
          var isLast = i === lines.length - 1;
          var lp = card.querySelector('[data-line-price="' + i + '"]');
          if (lp) lp.textContent = money(isLast && off > 0 ? Math.max(price - off, 0) : price, f);
          if (isLast) {
            var was = card.querySelector('[data-line-was]');
            if (was) was.textContent = money(price, f);
          }
        });
        if (off > 0 && off <= total) total -= off;
        card.querySelector('[data-total]').textContent = money(total, f);
        var u = card.querySelector('[data-unit]');
        if (u) u.textContent = money(Math.floor(total / qty), f);
        var c = card.querySelector('[data-compare]');
        if (c) { c.hidden = !(compare > total); c.textContent = compare > total ? money(compare, f) : ''; }
        var btn = card.querySelector('[data-add]');
        if (btn) {
          btn.disabled = !ok;
          btn.querySelector('[data-btn-label]').textContent = ok ? btn.dataset.label : btn.dataset.soldout;
        }
      }

      add(card, btn) {
        var self = this;
        var qty = Math.max(1, Number(card.dataset.qty || 1));
        var items = Array.from(card.querySelectorAll('[data-line]')).map(function (l) { return { id: Number(l.dataset.variant), quantity: qty }; });
        if (!items.length) return;
        var err = card.querySelector('[data-error]');
        if (err) err.hidden = true;
        var mode = this.dataset.afterAdd;
        var themeCart = mode === 'theme' ? (document.querySelector('cart-drawer') || document.querySelector('cart-notification')) : null;
        if (themeCart && typeof themeCart.getSectionsToRender !== 'function') themeCart = null;
        var payload = { items: items };
        if (themeCart) {
          payload.sections = themeCart.getSectionsToRender().map(function (s) { return s.section || s.id; });
          payload.sections_url = window.location.pathname;
          if (typeof themeCart.setActiveElement === 'function') themeCart.setActiveElement(btn);
        }
        btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
        var leaving = false;
        fetch(this.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Une erreur est survenue.'); return d; }); })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('zp:offer-added', { detail: { items: items, response: data } }));
            if (themeCart && data.sections) {
              var first = (data.items && data.items[0]) || {};
              themeCart.classList.remove('is-empty');
              themeCart.renderContents(Object.assign({}, first, { sections: data.sections }));
            } else if (mode === 'checkout') {
              leaving = true; window.location.href = self.root + 'checkout';
            } else {
              leaving = true; window.location.href = self.dataset.cartUrl || self.root + 'cart';
            }
          })
          .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } })
          .finally(function () { if (!leaving) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
      }
    }
    customElements.define('zp-offers', ZpOffers);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('zp-carousel')) return;
    class ZpCarousel extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        var step = function (dir) {
          var item = self.track.querySelector(':scope > *');
          var gap = parseFloat(getComputedStyle(self.track).columnGap) || 0;
          var w = item ? item.getBoundingClientRect().width + gap : self.track.clientWidth;
          var per = Math.max(1, Math.floor((self.track.clientWidth + gap) / w) - 1) || 1;
          self.track.scrollBy({ left: dir * w * per, behavior: 'smooth' });
        };
        if (this.prev) this.prev.addEventListener('click', function () { step(-1); });
        if (this.next) this.next.addEventListener('click', function () { step(1); });
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() { window.removeEventListener('resize', this.update); }
      update() {
        if (!this.prev || !this.next) return;
        var t = this.track;
        this.prev.disabled = t.scrollLeft <= 2;
        this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }
    }
    customElements.define('zp-carousel', ZpCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-setup-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zp-setup-steps')) {
    class ZpSetupSteps extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.zp-st__tab'));
        this.panels = Array.from(this.querySelectorAll('.zp-st__panel'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.show(tab.dataset.platform));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            e.preventDefault();
            const i = this.tabs.indexOf(tab);
            const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
            this.show(next.dataset.platform);
            next.focus();
          });
        });
        if (this.hasAttribute('data-detect') && this.tabs.length && !window.Shopify?.designMode) {
          const ua = navigator.userAgent || '';
          if (/android/i.test(ua)) this.show('android');
          else if (/iphone|ipad|ipod/i.test(ua)) this.show('ios');
        }
        this.onBlockSelect = (e) => {
          const li = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
          const panel = li && li.closest('.zp-st__panel');
          if (panel) this.show(panel.dataset.panel);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      show(platform) {
        if (!this.panels.some((p) => p.dataset.panel === platform)) return;
        this.tabs.forEach((t) => {
          const on = t.dataset.platform === platform;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((p) => { p.hidden = p.dataset.panel !== platform; });
        const list = this.querySelector(`.zp-st__panel[data-panel="${platform}"] .zp-st__list`);
        if (list) list.scrollLeft = 0;
      }
    }
    customElements.define('zp-setup-steps', ZpSetupSteps);
  }

  } catch(e) { console.error(e); }
})();
})();
